import React, { useEffect, useState, useRef } from 'react';
import { RefreshCwIcon } from 'lucide-react';
interface PullToRefreshProps {
  onRefresh: () => Promise<void>;
  children: React.ReactNode;
}
export function PullToRefresh({
  onRefresh,
  children
}: PullToRefreshProps) {
  const [pulling, setPulling] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const [pullDistance, setPullDistance] = useState(0);
  const startY = useRef(0);
  const containerRef = useRef<HTMLDivElement>(null);
  const threshold = 80;
  const handleTouchStart = (e: TouchEvent) => {
    if (window.scrollY === 0) {
      startY.current = e.touches[0].clientY;
    }
  };
  const handleTouchMove = (e: TouchEvent) => {
    if (window.scrollY !== 0 || refreshing) return;
    const currentY = e.touches[0].clientY;
    const distance = currentY - startY.current;
    if (distance > 0) {
      setPulling(true);
      setPullDistance(Math.min(distance, threshold * 1.5));
    }
  };
  const handleTouchEnd = async () => {
    if (pullDistance >= threshold && !refreshing) {
      setRefreshing(true);
      setPullDistance(threshold);
      if (navigator.vibrate) {
        navigator.vibrate(20);
      }
      try {
        await onRefresh();
      } finally {
        setRefreshing(false);
        setPulling(false);
        setPullDistance(0);
      }
    } else {
      setPulling(false);
      setPullDistance(0);
    }
  };
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    container.addEventListener('touchstart', handleTouchStart, {
      passive: true
    });
    container.addEventListener('touchmove', handleTouchMove, {
      passive: true
    });
    container.addEventListener('touchend', handleTouchEnd);
    return () => {
      container.removeEventListener('touchstart', handleTouchStart);
      container.removeEventListener('touchmove', handleTouchMove);
      container.removeEventListener('touchend', handleTouchEnd);
    };
  }, [pullDistance, refreshing]);
  const rotation = refreshing ? 360 : pullDistance / threshold * 360;
  return <div ref={containerRef} className="relative" data-id="element-5607" data-mp="3sohn4kwj5ccy">
      {/* Pull to refresh indicator */}
      <div className="absolute top-0 left-0 right-0 flex justify-center items-center transition-all duration-200 z-50" style={{
      transform: `translateY(${pulling || refreshing ? pullDistance - 60 : -60}px)`,
      opacity: pulling || refreshing ? 1 : 0
    }} data-id="element-5608" data-mp="1e96ue82c470">
        <div className="bg-white rounded-full shadow-lg p-3" data-id="element-5609" data-mp="39xqe5kggfnz3">
          <RefreshCwIcon className={`w-6 h-6 text-[#1E2B55] ${refreshing ? 'animate-spin' : ''}`} style={{
          transform: refreshing ? 'none' : `rotate(${rotation}deg)`
        }} data-id="element-5610" data-mp="3ew1rw69veiml" />
        </div>
      </div>
      {children}
    </div>;
}